import { setPageErrorInfo } from './digitalDataBuilder';

export const buildBaseEventData = (primaryCategory, eventName) => {
  const baseObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
  };

  return baseObject;
};

export const buildBcomAnalyticsEvent = (primaryCategory, eventName, { omsId, productName, brand }) => {
  const eventData = buildBaseEventData(primaryCategory, eventName);

  if (omsId) {
    eventData.item = [{
      productInfo: {
        sku: `${omsId}`,
        productName,
        manufacturer: `${brand}`,
        productType: 'merchandise',
      },
    }];
  }

  return eventData;
};

export const buildSubContentAnalyticsEvent = (primaryCategory, eventName, subContent) => {
  const subContentObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
    subContent: { ...subContent },
  };

  return subContentObject;
};

export const buildItemAnalyticsEvent = (primaryCategory, eventName, items) => {
  const { sku } = window?.digitalData?.product[0]?.productInfo ?? {};
  const itemList = items.map(({ quantity, retail }) => ({
    listLocation: 'pip', quantity, price: { basePrice: retail }, productInfo: { sku },
  }));
  const itemObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
    item: [...itemList],
  };

  return itemObject;
};

export const buildCartAnalyticsEvent = (cartID, primaryCategory, eventName, items) => {
  if (typeof window === 'undefined') {
    return {};
  }
  const { sku } = window.digitalData.product[0].productInfo;
  const itemList = items.map(({ quantity, retail }) => ({
    quantity, price: { basePrice: retail }, productInfo: { sku }, fulfillment: { method: 'sth' },
  }));

  const cartObject = {
    cart: { cartID },
    category: { primaryCategory },
    eventInfo: { eventName },
    overlayLocation: 'pip',
    item: [...itemList],
  };

  return cartObject;
};

export const buildStashAnalyticsEvent = (primaryCategory, eventName) => {
  if (typeof window === 'undefined') {
    return {};
  }
  const { sku } = window.digitalData.product[0].productInfo;
  const stashObject = {
    category: { primaryCategory },
    eventInfo: { eventName },
    eventMode: 'stash',
    stash: {
      component: '',
      item: [{
        'display position': 'n/a',
        productInfo: {
          sku,
        },
      }],
      pageType: 'pip',
      section: 'buybox',
      sharedSection: 'n/a',
      target: 'atc',
    },

  };

  return stashObject;
};

export const buildErrorAnalyticsEvent = (errorObject, primaryCategory, eventName) => {
  if (!primaryCategory) {
    setPageErrorInfo(errorObject);
    return null;
  }
    const errorAnalyticObject = {
    category: { primaryCategory },
    eventInfo: {
      eventName,
      error: [{
        ...errorObject,
      }],
    },
  };
  return errorAnalyticObject;
};
